import React from 'react';
import { Skeleton } from 'antd';
import { useTranslations } from 'next-intl';

import { useAutoTest } from 'modules/auto-test';
import { isEmptyArr } from 'modules/global';

import { EmptyData, Visible } from 'components';

import TestCard from './test-card';

const TopicTestSection = () => {
  const t = useTranslations();

  const { tests, isLoading } = useAutoTest();

  return (
    <div className="mt-15">
      <h1 className="text-center text-xl font-semibold">{t('barcha_avto_testlar')}</h1>

      <Visible
        if={isLoading}
        else={
          <Visible
            if={isEmptyArr(tests)}
            else={
              <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                {tests?.map(test => (
                  <React.Fragment key={test?.test_id}>
                    <TestCard
                      key={test?.test_id}
                      test={test}
                    />
                  </React.Fragment>
                ))}
              </div>
            }
          >
            <EmptyData title={t('common.empty_test_data')} />
          </Visible>
        }
      >
        <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {Array.from({ length: 10 }).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Skeleton.Button key={index} active className="!h-40 !w-full !rounded-xl" />
          ))}
        </div>
      </Visible>
    </div>
  );
};

export default TopicTestSection;
